export function installNumericInputGuard(target = document) {
  const numeric = event => event.target instanceof HTMLInputElement && event.target.type === 'number';
  const keydown = event => {
    if (numeric(event) && ['ArrowUp', 'ArrowDown'].includes(event.key)) event.preventDefault();
  };
  const wheel = event => {
    if (numeric(event) && event.target === target.activeElement) event.preventDefault();
  };
  target.addEventListener('keydown', keydown, true);
  target.addEventListener('wheel', wheel, {capture: true, passive: false});
  return () => {
    target.removeEventListener('keydown', keydown, true);
    target.removeEventListener('wheel', wheel, true);
  };
}
